<div class="app-page">

    <div class="app-page-header">
        <div>
            <h1 class="app-page-title">
                SMTP Configuration
            </h1>

            <p class="app-page-subtitle">

                {{
                    isUpdateMode
                        ? 'View or update the SMTP configuration for this client.'
                        : 'Configure SMTP settings for this client.'
                }}

            </p>
        </div>
    </div>

    <div class="app-panel app-panel-form">

        <div class="app-panel-body">

            <form
                [formGroup]="smtpForm"
                (ngSubmit)="onRegister()">

                <div class="app-form-grid">

                    <!-- Mail Provider -->
                    <div class="app-form-col">

                        <mat-form-field
                            appearance="outline"
                            class="app-full-width">

                            <mat-label>Mail Provider</mat-label>

                            <mat-select
                                formControlName="mailProvider"
                                (selectionChange)="onProviderChange()">

                                <mat-option
                                    *ngFor="let provider of mailProviderOptions"
                                    [value]="provider.value">

                                    {{ provider.viewValue }}

                                </mat-option>

                            </mat-select>

                            <mat-error
                                *ngIf="smtpForm.controls.mailProvider.errors?.required">

                                Mail provider is required!

                            </mat-error>

                        </mat-form-field>

                    </div>

                    <!-- Port -->
                    <!-- <div class="app-form-col">

                        <mat-form-field
                            appearance="outline"
                            class="app-full-width">

                            <mat-label>Port</mat-label>

                            <input
                                matInput
                                type="number"
                                formControlName="port"
                                placeholder="587">

                            <mat-error
                                *ngIf="smtpForm.controls.port.errors?.required">
                                This field is required!
                            </mat-error>

                            <mat-error
                                *ngIf="
                                    smtpForm.controls.port.errors?.min ||
                                    smtpForm.controls.port.errors?.max
                                ">
                                Please enter a valid port.
                            </mat-error>

                        </mat-form-field>

                    </div> -->

                        <!-- Credential Type -->
                        <!-- <div
                            class="app-form-col"
                            *ngIf="selectedProvider === 'MICROSOFT_365'">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>Credential Type</mat-label>

                                <mat-select
                                    formControlName="credentialType"
                                    (selectionChange)="onCredentialTypeChange()">

                                    <mat-option
                                        *ngFor="let type of credentialTypeOptions"
                                        [value]="type.value">

                                        {{ type.viewValue }}

                                    </mat-option>

                                </mat-select>

                                <mat-error
                                    *ngIf="smtpForm.controls.credentialType.errors?.required">
                                    Credential type is required!
                                </mat-error>

                            </mat-form-field>

                        </div> -->


                        <!-- Encryption Type -->
                        <!-- <div class="app-form-col">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>Encryption Type</mat-label>

                                <mat-select formControlName="encryptionType">

                                    <mat-option
                                        *ngFor="let type of encryptionTypeOptions"
                                        [value]="type.value">

                                        {{ type.viewValue }}

                                    </mat-option>

                                </mat-select>

                                <mat-error
                                    *ngIf="smtpForm.controls.encryptionType.errors?.required">
                                    This field is required!
                                </mat-error>

                            </mat-form-field>

                        </div> -->


                    <ng-container *ngIf="isSmtpCredential">

                        <!-- Username -->
                        <div class="app-form-col">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>
                                    {{
                                        selectedProvider === 'GMAIL'
                                            ? 'Gmail Account'
                                            : 'Username'
                                    }}
                                </mat-label>

                                <input
                                    matInput
                                    formControlName="username"
                                    autocomplete="off">

                                <mat-error
                                    *ngIf="smtpForm.controls.username.errors?.required">

                                    Username is required!

                                </mat-error>

                            </mat-form-field>

                        </div>


                        <!-- Password -->
                        <div class="app-form-col">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>
                                    {{
                                        isUpdateMode
                                            ? 'New Password'
                                            : (
                                                selectedProvider === 'GMAIL'
                                                    ? 'App Password'
                                                    : 'Password'
                                            )
                                    }}
                                </mat-label>

                                <input
                                    matInput
                                    type="password"
                                    formControlName="password"
                                    autocomplete="new-password">

                                <mat-hint *ngIf="isUpdateMode">
                                    Leave empty to keep the existing password.
                                </mat-hint>

                                <mat-error
                                    *ngIf="smtpForm.controls.password.errors?.required">

                                    Password is required!

                                </mat-error>

                            </mat-form-field>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="isMicrosoftOAuth">

                        <!-- Tenant ID -->
                        <div class="app-form-col">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>Tenant ID</mat-label>

                                <input
                                    matInput
                                    formControlName="tenantId"
                                    autocomplete="off">

                                <mat-error
                                    *ngIf="smtpForm.controls.tenantId.errors?.required">

                                    Tenant ID is required!

                                </mat-error>

                            </mat-form-field>

                        </div>


                        <!-- Application Client ID -->
                        <div class="app-form-col">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>
                                    Application Client ID
                                </mat-label>

                                <input
                                    matInput
                                    formControlName="oauthClientId"
                                    autocomplete="off">

                                <mat-error
                                    *ngIf="smtpForm.controls.oauthClientId.errors?.required">

                                    Application Client ID is required!

                                </mat-error>

                            </mat-form-field>

                        </div>


                        <!-- Client Secret -->
                        <div class="app-form-col">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>
                                    {{
                                        isUpdateMode
                                            ? 'New Client Secret'
                                            : 'Client Secret'
                                    }}
                                </mat-label>

                                <input
                                    matInput
                                    type="password"
                                    formControlName="clientSecret"
                                    autocomplete="new-password">

                                <mat-hint *ngIf="isUpdateMode">
                                    Leave empty to keep the existing client secret.
                                </mat-hint>

                                <mat-error
                                    *ngIf="smtpForm.controls.clientSecret.errors?.required">

                                    Client Secret is required!

                                </mat-error>

                            </mat-form-field>

                        </div>

                    </ng-container>


                    <!-- From Email -->
                    <div class="app-form-col">

                        <mat-form-field
                            appearance="outline"
                            class="app-full-width">

                            <mat-label>From Email</mat-label>

                            <input
                                matInput
                                formControlName="fromEmail"
                                placeholder="notifications@gentledental.com">

                            <mat-error
                                *ngIf="smtpForm.controls.fromEmail.errors?.required">
                                This field is required!
                            </mat-error>

                            <mat-error
                                *ngIf="smtpForm.controls.fromEmail.errors?.email">
                                Please enter a valid email.
                            </mat-error>

                        </mat-form-field>

                    </div>


                    <!-- From Name -->
                    <div class="app-form-col">

                        <mat-form-field
                            appearance="outline"
                            class="app-full-width">

                            <mat-label>From Name</mat-label>

                            <input
                                matInput
                                formControlName="fromName"
                                placeholder="Gentle Dental">

                            <mat-error
                                *ngIf="smtpForm.controls.fromName.errors?.required">
                                This field is required!
                            </mat-error>

                        </mat-form-field>

                    </div>

                </div>


                <!-- Receiver Emails -->
                <div class="smtp-email-section">

                    <div class="smtp-email-header">

                        <div>
                            <h3>Receiver Emails</h3>

                            <p>
                                Add the email addresses that should receive
                                notifications.
                            </p>
                        </div>

                        <button
                            type="button"
                            mat-raised-button
                            color="primary"
                            class="btn app-btn app-btn-primary"
                            (click)="addEmail()">

                            + Add Email

                        </button>

                    </div>


                    <div
                        formArrayName="emails"
                        class="smtp-email-list">

                        <div
                            *ngFor="
                                let emailControl of emails.controls;
                                let i = index
                            "
                            class="smtp-email-row">

                            <mat-form-field
                                appearance="outline"
                                class="app-full-width">

                                <mat-label>
                                    Receiver Email {{ i + 1 }}
                                </mat-label>

                                <input
                                    matInput
                                    [formControlName]="i"
                                    placeholder="admin@gentledental.com">

                                <mat-error
                                    *ngIf="emailControl.errors?.required">
                                    Email is required!
                                </mat-error>

                                <mat-error
                                    *ngIf="emailControl.errors?.email">
                                    Please enter a valid email.
                                </mat-error>

                            </mat-form-field>


                            <button
                                *ngIf="emails.length > 1"
                                type="button"
                                mat-icon-button
                                color="warn"
                                class="smtp-remove-email"
                                (click)="removeEmail(i)"
                                aria-label="Remove email">

                                <mat-icon>delete</mat-icon>

                            </button>

                        </div>

                    </div>

                </div>


                <!-- Actions -->
                <div class="app-form-actions">

                    <button
                        type="button"
                        (click)="onCancel()"
                        class="btn app-btn app-btn-secondary">

                        Cancel

                    </button>


                    <button
                        class="btn app-btn app-btn-primary"
                        mat-raised-button
                        color="primary"
                        type="submit"
                        [disabled]="smtpForm.invalid || isLoading">

                        {{ isUpdateMode ? 'Update' : 'Register' }}

                    </button>

                </div>

            </form>

        </div>

    </div>

</div>